import {
  SupportTicketCommentDTO,
  SupportTicketStatus,
  UpdateSupportTicketStatusRequestDTO,
} from '../dtos/AdminSupportTickets.dto';
import { SupportTicketCommentRequestDTO } from '../dtos/SupportTicketComment.dto';
import { SupportTicketReplyRequestDTO } from '../dtos/SupportTicketReply.dto';
import { SupportTicketModel } from '../models/SupportTicket.model';
import { SupportTicketCommentModel } from '../models/SupportTicketComment.model';

export class SupportTicketCommentUtil {
  public static mapToViewModel(
    dto: SupportTicketCommentDTO,
  ): SupportTicketCommentModel {
    return {
      id: dto.id,
      comment: dto.message,
      postedOn: dto.timestamp,
      posterDetails: {
        initials: `${dto.commenter.firstName[0]}${dto.commenter.lastName[0]}`,
        name: dto.commenter.fullName,
        email: dto.commenter.email,
        role: dto.commenter.role,
        id: dto.commenter.memberId ? dto.commenter.memberId : undefined,
      },
      parents: dto.parents ? dto.parents : [],
      replies: dto.replies
        ? dto.replies.map((item) => this.mapToViewModel(item))
        : [],
    };
  }

  public static createAdminCommentReplyDTO(
    supportTicket?: SupportTicketModel,
    comment?: SupportTicketCommentModel,
  ): SupportTicketReplyRequestDTO {
    return {
      ticketId: supportTicket ? supportTicket.id : undefined,
      message: '',
      email: 'support@aivia.ca',
      firstName: 'Support',
      lastName: 'Team Member',
      parents: comment
        ? comment.parents
          ? [...comment.parents, comment.id]
          : [comment.id]
        : [],
    };
  }

  public static createCommunityCommentReplyDTO(
    supportTicket?: SupportTicketModel,
    comment?: SupportTicketCommentModel,
  ): SupportTicketReplyRequestDTO {
    return {
      ticketId: supportTicket ? supportTicket.id : undefined,
      message: '',
      parents: comment
        ? comment.parents
          ? [...comment.parents, comment.id]
          : [comment.id]
        : [],
    };
  }

  public static toAdminCommentRequestDTO(
    supportTicket?: SupportTicketModel,
  ): SupportTicketCommentRequestDTO {
    return {
      ticketId: supportTicket ? supportTicket.id : undefined,
      message: '',
      email: 'support@aivia.ca',
      firstName: 'Support',
      lastName: 'Team Member',
    };
  }

  public static toCommentRequestDTO(
    supportTicket?: SupportTicketModel,
  ): SupportTicketCommentRequestDTO {
    return {
      ticketId: supportTicket ? supportTicket.id : undefined,
      message: '',
    };
  }

  public static toStatusRequestDTO(
    supportTicket?: SupportTicketModel,
  ): UpdateSupportTicketStatusRequestDTO {
    return {
      ticketId: supportTicket ? supportTicket.id : undefined,
      status: supportTicket
        ? (supportTicket.status as SupportTicketStatus)
        : undefined,
    };
  }
}
